<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-26 18:15:08
 * @LastEditTime: 2021-01-20 11:32:47
 * @LastEditors: daikeyi
 -->
<template>
    <div id="page_Container" class="exchangecoupon-wrapper">
        <div class="page">
            <div id="main-container" class="main-container">
                <div class="instruction-wrapper">
                    <ul class="instr-ul-wrapper">
                        <li class="list-item">1.兑换码获取：由8位数字和字母组合而成的优惠券兑换规则。</li>
                        <li class="list-item">2.兑换码使用：在当前页面输入兑换码即可兑换相应优惠券。一个兑换码只能兑换一张优惠券，不可重复使用。</li>
                    </ul>
                </div>
                <div class="input-wrapper">
                    <van-cell-group>
                        <van-field label="兑换码：" required v-model="couponCode" placeholder="请输入8位兑换码" :error-message="errMessage"
                        @blur="onBlur" />
                    </van-cell-group>
                </div>
                <div class="btn-wrapper" @click="submit">
                    <van-button round type="danger">立即兑换</van-button>
                </div>
            </div>
            <div class="popup-wrapper">
                <van-popup v-model="showPopup">
                    <img src="../assets/img/incoupon/Shape@2x.png" alt="" class="icon">
                    <h1 class="title">兑换成功</h1>
                    <span class="desc">{{limit}}s后跳转到我的优惠券</span>
                </van-popup>
            </div>
        </div>
    </div>
</template>
<script>
import { Toast } from 'vant';
import { toastLoading, clearToastLoading } from '@/utils/base/utils';

export default {
    data() {
        return {
            couponCode: '',
            errMessage: '',
            showPopup: false,
            limit: 5
        };
    },

    methods: {
        // 兑换优惠券
        submit() {
            const validate = this.validate();
            if (!validate) {
                return false;
            }
            // this.showPopup = true;

            // this.setTimer()
            this.doExchange();
        },

        doExchange() {
            const ths = this;
            const params = {
                couponCode: ths.couponCode
            };
            ths.$doRequest(
                {
                    url: '/coupon/receiveCouponByCouponCode',
                    params: params,
                    before: function() {
                        ths.loading = toastLoading();
                    },
                    complete: function() {
                        clearToastLoading(ths.loading);
                    }
                },
                function(data) {
                    if (data.responseCode === '100000') {
                        ths.showPopup = true;
                        ths.setTimer();
                    } else {
                        Toast(data.message);
                    }
                }
            );
        },
        // 验证
        validate() {
            const regexp = /^[a-zA-Z0-9]{8}$/;
            this.errMessage = this.couponCode !== '' ? (regexp.test(this.couponCode) === true ? '' : '请输入8位正确的兑换码') : '请输入兑换码';
            return this.errMessage === '';
        },
        // 失去焦点
        onBlur() {
            this.validate();
        },
        // 定时器
        setTimer() {
            this.timer = null;
            this.timer = setInterval(() => {
                if (this.limit === 0) {
                    this.clearTimer();
                    this.esvOpenPage({
                        name: 'OPCoupon'
                    });
                } else {
                    this.limit -= 1;
                }
            }, 1000);
        },

        // 清除定时器
        clearTimer() {
            clearInterval(this.timer);
        },

        destoryed() {
            this.clearTimer();
        }
    }
};
</script>
<style lang="scss">
    .instr-ul-wrapper {
        padding: 12px 12px 0;
        .list-item {
            list-style: none;
            color: #999;
            font-size: 12px;
            margin-bottom: 12px;
        }
    }
    .input-wrapper {
        .van-cell .van-cell__title {
            margin-right: 10px;
        }
    }
    .btn-wrapper {
        position: fixed;
        bottom: 50px;
        left: 50%;
        transform: translate3d(-50%, 0, 0);
        width: 80%;
        .van-button--danger {
            background: #EE2E50!important;
            width: 100%;
        }
    }
    .popup-wrapper {
        .van-popup {
            width: 70%;
            height: 40%;
            text-align: center;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            .title {
                font-weight: normal;
                font-size: 18px;
                margin: 18px 0 10px 0;
            }
            .desc {
                color: #999;
                font-size: 14px;
            }
            .icon {
                width: 65px;
                height: 65px;
            }
        }
    }
</style>
